import React, { useState, useEffect } from 'react';
import {InputGroup,InputGroupAddon,InputGroupText,Row,Col, Button} from 'reactstrap';
import ForgotPassword_step1 from "../../views/ForgotPassword/ForgotPassword_step1";
import RememberMe from "./RememberMe";
import brandingLogo from '../../assets/images/branding-logo.png';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { authenticationService } from '../../jwt/_services';
import SocialLogin from './socialLogin';
import IubendaCookieConsent from '../../components/iubendaCookieConsent';
import LoaderInner from "../../components/LoaderInner";
import OtpModal from "../../components/otpModal";

const DISPLAY_LOGO = process.env.REACT_APP_BRANDING_AUTH_FORM_DISPLAY_LOGO;
const FORM_ALIGNMENT = process.env.REACT_APP_BRANDING_AUTH_FORM_ALIGNMENT;
const SELF_SIGNUP_ENABLED = process.env.REACT_APP_BRANDING_AUTH_FORM_SELF_SIGNUP_ENABLED;
const GOOGLE_OAUTH_ENABLED = process.env.REACT_APP_BRANDING_AUTH_FORM_GOOGLE_OAUTH_ENABLED;

const sidebarBackground = {
	backgroundRepeat: "no-repeat",
	backgroundPosition: "bottom center"
};

const Login = (props) => {
	const [isLoading, setIsLoading] = useState(false);
	const [showOtpModal, setShowOtpModal] = useState(false);
	const [defaultTwoFactorMethod, setDefaultTwoFactorMethod] = useState("");
	const [availableTwoFactorMethods, setAvailableTwoFactorMethods] = useState([]);
	const [user, setUser] = useState("");

	const formAlignment = FORM_ALIGNMENT;
	const displayLogo = DISPLAY_LOGO === "yes" ? true: false;
	const signUpEnabled = SELF_SIGNUP_ENABLED === "yes" ? true: false;
	const googleOAuthEnabled = GOOGLE_OAUTH_ENABLED === "yes" ? true: false;

	const handleClick = () => {
        var elem = document.getElementById('loginform');
        elem.style.transition = "all 2s ease-in-out";
        elem.style.display = "none";
        document.getElementById('recoverform').style.display = "block";
    };

    const handleToLogin = () => {
        var elem = document.getElementById('recoverform');
        elem.style.transition = "all 2s ease-in-out";
        elem.style.display = "none";
        document.getElementById('loginform').style.display = "block";
    };

    useEffect(() => {
        if (authenticationService.currentUserValue?.value) {
            const { from } = props.location.state || { from: { pathname: "/" } };
            props.history.push(from);
        }
    }, [props.history, props.location.state]);

		return (
			<div className="">
				{/*--------------------------------------------------------------------------------*/}
				{/*Login Cards*/}
				{/*--------------------------------------------------------------------------------*/}
				<div className="auth-wrapper d-flex no-block justify-content-center align-items-center bg-primary" style={sidebarBackground}>
					<div className={`auth-box on-sidebar-${formAlignment}`} style={{borderRadius: (formAlignment === "center")? "8px": "0px" }}>
						<div id="loginform">
							<Row>
								<Col lg="12" className="bg-white">
									{displayLogo &&
										<div className="text-center p-1">
											<img src={brandingLogo} alt="logo" className="img-fluid" style={{maxHeight: 150, maxWidth: 300}} />
										</div>
									}
									<div className="p-4">
										<h3 className="font-medium mb-3">Log In to your account</h3>
										<Formik
												initialValues={{
													username: '',
													password: ''
												}}
												validationSchema={Yup.object().shape({
													username: Yup.string().required('Email is required'),
													password: Yup.string().required('Password is required')
												})}
												onSubmit={({ username, password }, { setStatus, setSubmitting }) => {
													setIsLoading(true);
													setStatus("");
													authenticationService.login(username, password)
													.then(
														user => {
															setUser(user);
															authenticationService.request2FAToken(user).then(
																response => {
																	// console.log(response);
																	setDefaultTwoFactorMethod(response.two_factor_method);
																	setAvailableTwoFactorMethods(response.available_methods);
																	setIsLoading(false);
																	setSubmitting(false);
																	setShowOtpModal(true);
																},
																error => {
																	setIsLoading(false);
																	setSubmitting(false);
																	setAvailableTwoFactorMethods([]);
																	setStatus("Something went wrong! Please refresh page and try again!");
																}
															);
														},
														error => {
															setIsLoading(false);
															setSubmitting(false);
															setAvailableTwoFactorMethods([]);
															setStatus(error);
														}
													);
												}}
												render={({ errors, status, touched, isSubmitting }) => (
													<Form className="mt-3" id="loginform">
														<InputGroup className="mb-3">
															<InputGroupAddon addonType="prepend">
																<InputGroupText>
																	<i className="ti-email"></i>
																</InputGroupText>
															</InputGroupAddon>

															<Field name="username" type="text" className={'form-control' + (errors.username && touched.username ? ' is-invalid' : '')} />
															<ErrorMessage name="username" component="div" className="invalid-feedback" />
														</InputGroup>
														<InputGroup className="mb-3">
															<InputGroupAddon addonType="prepend">
																<InputGroupText>
																	<i className="ti-lock"></i>
																</InputGroupText>
															</InputGroupAddon>
															<Field name="password" type="password" className={'form-control' + (errors.password && touched.password ? ' is-invalid' : '')} />
															<ErrorMessage name="password" component="div" className="invalid-feedback" />

														</InputGroup>
														<div className="d-flex no-block align-items-center mb-3">
															<RememberMe />
														</div>
														<Row className="mb-3">
															<Col xs="12">
																<Button size="lg" color="primary" type="submit" block disabled={isSubmitting}>Login</Button>
															</Col>
														</Row>
														{status &&
															<div className={'alert alert-danger'}>{status}</div>
														}
														
														{
															signUpEnabled &&
															<div className="justify-content-center d-flex align-items-center">
																Don't have an account? <a href="/authentication/signup" style={{paddingLeft: 6}} className="forgot text-cyan float-right">Register</a>
															</div>
														}

														<div className="justify-content-center d-flex align-items-center">
															Forgot password? <a href="#recoverform" id="to-recover" style={{paddingLeft: 6}} onClick={handleClick} className="forgot text-cyan float-right">Reset</a>
														</div>

														{
															googleOAuthEnabled &&
															<>
																<hr/>
																<h4 className="text-center text-bold">Or</h4>
																<div className="text-center">
																	<SocialLogin />
																</div>
															</>
														}
													</Form>
												)}
											/>
									</div>

								</Col>
							</Row>
						</div>
						<div id="recoverform">
							<ForgotPassword_step1 handleToLogin={handleToLogin} formAlignment={formAlignment} displayLogo={displayLogo} logoUrl={brandingLogo} />
						</div>
						<IubendaCookieConsent />
					</div>
				</div>
				<LoaderInner show={isLoading} />
				<OtpModal
					user={user}
					isOpen={showOtpModal}
					setOpen={setShowOtpModal}
					defaultTwoFactorMethod={defaultTwoFactorMethod}
					availableTwoFactorMethods={availableTwoFactorMethods}
				/>
			</div>
		);
};

export default Login;
